import { getClientApiProxyUrl } from '../api/consts';

export type InvoiceType = {
  id: number;
  createdAt: string; // ISO date string
  reference: string; // Processor invoice reference string
  lineItems: { description: string }[];
  type: 'invoice' | 'receipt';
};

export class Invoice {
  date: Date;
  url: string;
  name: string;

  constructor(private readonly args: { baseUrl: string; forceDownload?: boolean; invoice: InvoiceType }) {
    this.date = new Date(this.args.invoice.createdAt);
    this.name = `ecologi-${this.args.invoice.type}-${this.args.invoice.reference}.pdf`;
    this.url = `${getClientApiProxyUrl(
      this.args.baseUrl,
      `/${this.args.invoice.type}s/${this.args.invoice.reference}.pdf`,
    )}${this.args.forceDownload ? '?download=true' : ''}`;
  }
}
